/* Bloom PDP enhancements (test build), Mejuri 1:1 pass 3:
   1. Trust badges rebuilt as Mejuri-style icon rows using custom Gemini-generated
      line icons (theme assets bloom-badge-*.png). Locked wording only.
   2. Material text line above the swatches (selected value, live-updates); hides the
      theme's "Material" legend.
   3. Accordions moved under the image column (desktop), like Mejuri.
   4. VIEW MORE DETAILS link -> opens the Materials & Specifications accordion.
   5. Judge.me preview badge text -> "4.9".
   6. Wording backups (locale says Add to bag / Size Guide). */
(function () {
  function badgesFor(t) {
    if (t.indexOf('10k Solid Gold') !== -1)
      return [['gold', '10k Solid Gold'], ['durable', 'Made to Last'], ['returns', '30-Day Returns & Exchanges'], ['secure', 'Safe & Secure Checkout']];
    if (t.indexOf('Gold Vermeil') !== -1)
      return [['hypo', 'Hypoallergenic'], ['plating', 'Thick 18k Gold Plating'], ['returns', '30-Day Returns & Exchanges'], ['secure', 'Safe & Secure Checkout']];
    if (t.indexOf('Brass') !== -1)
      return [['plating', 'Thick 18k Gold Plating'], ['durable', 'Strong & Highly Durable'], ['returns', '30-Day Returns & Exchanges'], ['secure', 'Safe & Secure Checkout']];
    if (t.indexOf('Sterling Silver') !== -1)
      return [['gold', '925 Sterling Silver'], ['hypo', 'Hypoallergenic'], ['returns', '30-Day Returns & Exchanges'], ['secure', 'Safe & Secure Checkout']];
    return [['returns', '30-Day Returns & Exchanges'], ['secure', 'Safe & Secure Checkout']];
  }
  function applyBadges() {
    var desc = document.querySelector('.product__block.product__description');
    var dataEl = document.getElementById('bloom-materials-data');
    if (!desc) return false;
    if (document.querySelector('.bloom-badges')) return true;
    var t = '';
    if (dataEl) { try { t = JSON.parse(dataEl.textContent) || ''; } catch (e) { t = dataEl.textContent || ''; } }
    var list = badgesFor(t);
    var wrap = document.createElement('div');
    wrap.className = 'bloom-badges';
    list.forEach(function (b) {
      var el = document.createElement('div');
      el.className = 'bloom-badge';
      el.innerHTML = '<span class="bloom-badge-ic bic-' + b[0] + '"></span><span class="bloom-badge-tx">' + b[1] + '</span>';
      wrap.appendChild(el);
    });
    desc.insertAdjacentElement('afterend', wrap);
    return true;
  }
  function applyStoneWording() {
    var v = document.querySelector('.product__siblings .radio__legend__value');
    if (v && v.textContent.indexOf('Center Stone') === -1 && v.textContent.trim() !== '') {
      v.textContent = v.textContent.trim() + ' Center Stone';
    }
    return true;
  }
  function applyMaterialLine() {
    var swatchWrap = document.querySelector('.radio__fieldset--swatches');
    if (!swatchWrap) return true;
    var legend = swatchWrap.querySelector('.radio__legend');
    if (legend) legend.style.setProperty('display', 'none', 'important');
    var checked = swatchWrap.querySelector('input:checked');
    var value = checked ? checked.value : '';
    var line = document.querySelector('.bloom-material-line');
    if (!line) {
      line = document.createElement('div');
      line.className = 'bloom-material-line';
      swatchWrap.parentNode.insertBefore(line, swatchWrap);
    }
    if (value && line.textContent !== value) line.textContent = value;
    return true;
  }
  function moveAccordions() {
    if (window.matchMedia('(max-width: 749px)').matches) return true;
    if (document.querySelector('.bloom-under-images')) return true;
    var page = document.querySelector('.product__page');
    var images = page && (page.querySelector('product-images') || page.querySelector('.product__images'));
    var accs = document.querySelectorAll('.form__width .product__block--accordion');
    if (!page || !images || !accs.length) return false;
    var wrap = document.createElement('div');
    wrap.className = 'bloom-under-images';
    accs.forEach(function (a) { wrap.appendChild(a); });
    images.insertAdjacentElement('afterend', wrap);
    window.dispatchEvent(new Event('resize'));
    return true;
  }
  function applyViewMore() {
    var badges = document.querySelector('.bloom-badges');
    if (!badges) return false;
    if (document.querySelector('.bloom-view-more')) return true;
    var accordions = document.querySelectorAll('.product__block--accordion');
    var target = null;
    accordions.forEach(function (a) {
      if (!target && /materials/i.test(a.textContent)) target = a;
    });
    if (!target) return true;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bloom-view-more';
    btn.textContent = 'View more details';
    btn.addEventListener('click', function () {
      var trigger = target.querySelector('[data-collapsible-trigger], .accordion__title');
      if (trigger) trigger.click();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    badges.insertAdjacentElement('afterend', btn);
    return true;
  }
  function applyBadge() {
    var b = document.querySelector('.jdgm-prev-badge');
    if (!b) return false;
    var avg = parseFloat(b.getAttribute('data-average-rating') || '');
    var t = b.querySelector('.jdgm-prev-badge__text');
    if (!avg || !t) return false;
    var want = avg.toFixed(1);
    if (t.textContent.trim() !== want) t.textContent = want;
    return true;
  }
  function applyWording() {
    document.querySelectorAll('button[name="add"], [data-add-to-cart]').forEach(function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        if (/add to cart/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/add to cart/i, 'Add to bag');
      }
    });
    document.querySelectorAll('.radio__legend__link__label').forEach(function (el) {
      if (/size chart/i.test(el.textContent)) el.textContent = 'Size Guide';
    });
  }
  function applyPaymentLine() {
    var buttons = document.querySelector('.product__block--buttons');
    if (!buttons) return false;
    var priceEl = document.querySelector('.product__price__wrap .price') || document.querySelector('[data-product-price]');
    if (!priceEl) return false;
    var m = (priceEl.textContent || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
    if (!m) return false;
    var quarter = (parseFloat(m[1]) / 4).toFixed(2);
    var line = document.querySelector('.bloom-payline');
    if (!line) {
      line = document.createElement('div');
      line.className = 'bloom-payline';
      buttons.insertAdjacentElement('afterend', line);
    }
    if (line.dataset.amount !== quarter) {
      line.dataset.amount = quarter;
      line.innerHTML = '<span>or 4 interest-free payments of $' + quarter + ' with</span><span class="bloom-payline-logo" role="img" aria-label="Afterpay"></span>';
    }
    return true;
  }
  function applyAll() {
    try {
      applyBadges();
      applyPaymentLine();
      applyMaterialLine();
      applyStoneWording();
      moveAccordions();
      applyViewMore();
      applyWording();
      applyBadge();
    } catch (e) {}
  }
  document.addEventListener('change', function () { setTimeout(applyAll, 60); });
  var debounce;
  function observeRoot() {
    var root = document.querySelector('product-info');
    if (!root || root.dataset.bloomObserved) return !!root;
    root.dataset.bloomObserved = '1';
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(applyAll, 120);
    }).observe(root, { childList: true, subtree: true });
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    applyAll();
    var ob = observeRoot();
    if ((ob && tries > 10) || tries > 40) clearInterval(timer);
  }, 400);
})();
